import styled, { css } from 'styled-components';
import boxShadow from '../../configs/boxShadow';
import color from '../../configs/color';

const AdvanceFilterWrapper = styled.div`
  margin-top: 24px;
  background-color: ${(props) => {
    return props.refinerNewReport ? color.grey3 : 'white';
  }};
  border-radius: 12px;
  box-shadow: ${boxShadow.normal};
  .containers_advanceFilter_body {
    padding: 24px;
    .ant-form-item .ant-form-item-label > label {
      color: ${color.black3};
    }
    .subtitle,
    .title {
      margin-bottom: 24px;
    }
    .title {
      display: flex;
      justify-content: space-between;
    }
  }
  .containers_advanceFilter_footer {
    padding: 24px;
    background: ${color.grey3};
    border-radius: 0 0 12px 12px;
    display: flex;
    justify-content: space-between;
    .containers_advanceFilter_footer-search {
      button:first-child {
        margin-right: 8px;
        background: ${color.white};
        color: ${color.orange2};
      }
      button {
        box-shadow: unset;
      }
    }
    ${(props) => {
      return (
        props.refinerNewReport &&
        css`
          background: ${color.grey2};
          border-top: 1px solid ${color.grey1};
          justify-content: flex-end;
          .containers_advanceFilter_footer-search {
            button:first-child {
              margin-right: 8px;
            }
            button {
              box-shadow: unset;
              background: ${color.white};
              color: ${color.orange2};
              min-width: 168px;
            }
          }
        `
      );
    }}
  }
`;

export const AppliedFilterWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 12px;
  row-gap: 12px;
  margin-top: 24px;
`;

export const AppliedFilter = styled.div`
  text-transform: capitalize;
  padding: 12px;
  background: ${color.grey1};
  font-size: 14px;
  font-weight: 400;
  color: ${color.black1};
  border-radius: 8px;
  .anticon {
    margin-left: 24px;
  }
`;

export default AdvanceFilterWrapper;
